<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-10-16 17:53:41
-->
<template>
	<div>
		<el-drawer :title="title" :visible.sync="visible" :append-to-body="true" :size="width" :before-close="handleClose"
			:wrapperClosable="false" custom-class="drawer-template">
			<div class="content">
				<div class="mode line pb-24">
					<p class="yx-color-text-primary font-h4-regular">筛选条件</p>
					<div class="mt-24 cell-box">
						<template v-if="isSeachField">
							<div class="flex-row flex-align-center" v-for="(item, key, index) in paramsTextObj" :key="index">
								<span class="yx-color-text-regular font-h4-regular">{{ key }}</span>
								<el-tooltip :content="item" placement="top" v-ak-tooltip-auto-show>
									<span class="yx-color-text-primary ml-16 font-h4-regular line-ellipsis-1" style="max-width: 160px">{{
										item }}</span>
								</el-tooltip>
							</div>
						</template>
						<div class="yx-color-text-regular font-h4-regular" v-else>暂无</div>
					</div>
				</div>
				<div class="mode line pt-24 pb-24">
					<p class="yx-color-text-primary font-h4-regular">导出样式</p>
					<div class="mt-24">
						<el-radio v-model="exportType" label="2" class="mr-4" @change="getTypeField('2')">按样品规格导出【推荐】</el-radio>
						<explain content="按SKU（商品编码）进行发货，同个样品订单可拆分多包裹发货，适用于ERP批量导入发货"></explain>
						<el-radio v-model="exportType" label="1" class="ml-24 mr-4" @change="getTypeField('1')">按样品订单导出</el-radio>
						<explain content="按样品订单号进行发货，同个样品订单无法拆分包裹发货，适用于线下发货"></explain>
					</div>
				</div>
				<div class="mode pt-24 pb-24">
					<div class="flex-row flex-just-between">
						<p class="yx-color-text-primary font-h4-regular">
							报表字段
							<span class="font-h4-regular">（已选 {{ selectLength }} 个）</span>
						</p>
						<div>
							<el-checkbox v-model="allChecked" @change="allChange">全选</el-checkbox>
							<el-checkbox v-model="rememberChecked">记住本次选择</el-checkbox>
							<explain content="勾选后将记住本次选择的报表类型" class="ml-4"></explain>
						</div>
					</div>
					<div class="mt-24 check-box" v-loading="loadingBox">
						<div class="item" v-for="(item, index) in fieldList" :key="index">
							<el-checkbox v-model="item.selected" @change="changeSelect">
								<el-tooltip placement="top" :content="item.name" :disabled="isDisabledTooltip(item.name)">
									<span>{{ item.name | textFormat(8) }}</span>
								</el-tooltip>
							</el-checkbox>
						</div>
					</div>
				</div>
			</div>
			<div class="drawer-footer yx-background-white" style="z-index: 99">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading" :disabled="!selectLength">导出</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import { layoutGetField, exportSampleList } from '@/api/sampleOrder';
import { setFieldShow } from '@/api/common';

export default {
	props: {},
	components: {
		Explain,
	},
	data() {
		return {
			title: '导出样品订单', // 弹窗标题
			visible: false, // 弹窗显隐
			formData: {
				test: '',
			}, // 表单数据
			loading: false, // 按钮loading状态
			allChecked: false,
			rememberChecked: true,
			size: 'normal',
			exportType: '2',
			fieldList: [],
			params: {},
			loadingBox: false,
			paramsTextObj: {},
			isSeachField: 0,
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
		selectLength({ fieldList }) {
			return fieldList.filter(item => item.selected).length;
		},
	},
	methods: {
		// 主动显示弹窗
		show(params, obj = {}) {
			this.params = params;
			//过滤对象中的空值
			Object.keys(obj).forEach(key => {
				if (obj[key]) {
					this.paramsTextObj[key] = obj[key];
				}
			});
			this.isSeachField = Object.keys(this.paramsTextObj).length;
			this.getField();
			this.visible = true;
		},
		async getField(type = '2') {
			this.loadingBox = true;
			try {
				const list_type = type === '2' ? 'cyt_sample_list_spec_export' : 'cyt_sample_list_export';
				const { fieldList = [] } = await layoutGetField({ list_type });
				this.fieldList = fieldList.filter(v => {
					if (['promotion_task_id', 'promotion_task_name', 'task_order_num'].includes(v.key)) {
						return this.$auth.hasPermi('sample-order:promotion:source') ? true : false;
					} else {
						return true;
					}
				});
				this.changeSelect();
				this.loadingBox = false;
			} catch (e) {
				this.loadingBox = false;
			}
		},
		getTypeField(type) {
			this.allChecked = false;
			this.rememberChecked = true;
			this.getField(type);
		},
		// 清空数据并关闭弹窗
		handleClose() {
			(this.allChecked = false), (this.rememberChecked = true), (this.exportType = '2'), (this.loading = false), (this.paramsTextObj = {});
			// 关闭弹窗
			this.visible = false;
		},
		async allChange() {
			let arr = this.fieldList.filter(item => item.selected);
			if (arr.length < this.fieldList.length) {
				this.fieldList.forEach(item => {
					item.selected = true;
				});
			} else {
				this.fieldList.forEach(item => {
					item.selected = false;
				});
			}
		},
		// 确认按钮点击事件
		async confirm() {
			const { exportType } = this;
			const list_type = exportType === '2' ? 'cyt_sample_list_spec_export' : 'cyt_sample_list_export';
			const show_head_list = this.fieldList.filter(v => v.selected).map(k => k.key);
			this.loading = true;
			if (this.rememberChecked) {
				await setFieldShow({ show_head_list, list_type });
			}
			exportSampleList({ ...this.params, type: exportType, export_field: show_head_list })
				.then(res => {
					this.loading = false;
					window.open(res.download_url, '_blank');
					this.$message.success('导出成功');
					this.handleClose();
				})
				.catch(() => {
					this.loading = false;
					this.handleClose();
				});
		},
		changeSelect() {
			const length = this.fieldList.filter(v => v.selected)?.length;
			if (length === this.fieldList.length) {
				this.allChecked = true;
			} else {
				this.allChecked = false;
			}
		},
		isDisabledTooltip(name) {
			return !(name.length > 8);
		},
	},
	beforeDestroy() { },
};
</script>
<style lang="less" scoped>
.content {
	.line {
		border-bottom: 1px solid #f0f1f5;
	}

	/deep/ .el-checkbox__label {
		padding-left: 4px;
	}

	.mode {
		::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
			color: #4e596a;
		}
	}

	.check-box {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-gap: 12px;

		::v-deep .el-checkbox {
			display: flex;
			align-items: center;
		}
	}

	.cell-box {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 16px;
	}

	::v-deep .el-checkbox {
		font-weight: 400;
	}
}
</style>
